export const GET_EVERGREEN_LEADS = 'GET_EVERGREEN_LEADS';
export const GET_EVERGREEN_LEADS_SUCCESS = 'GET_EVERGREEN_LEADS_SUCCESS';
export const GET_EVERGREEN_LEADS_FAILURE = 'GET_EVERGREEN_LEADS_FAILURE';
export const GET_EVERGREEN_LEAD = 'GET_EVERGREEN_LEAD';
export const GET_EVERGREEN_LEAD_SUCCESS = 'GET_EVERGREEN_LEAD_SUCCESS';
export const GET_EVERGREEN_LEAD_FAILURE = 'GET_EVERGREEN_LEAD_FAILURE';
export const UPDATE_EVERGREEN_LEAD = 'UPDATE_EVERGREEN_LEAD';
export const UPDATE_EVERGREEN_LEAD_SUCCESS = 'UPDATE_EVERGREEN_LEAD_SUCCESS';
export const UPDATE_EVERGREEN_LEAD_FAILURE = 'UPDATE_EVERGREEN_LEAD_FAILURE';
export const CREATE_EVERGREEN_LEAD = 'CREATE_EVERGREEN_LEAD';
export const CREATE_EVERGREEN_LEAD_SUCCESS = 'CREATE_EVERGREEN_LEAD_SUCCESS';
export const CREATE_EVERGREEN_LEAD_FAILURE = 'CREATE_EVERGREEN_LEAD_FAILURE';

export const UPDATE_FILTER_EVERGREEN_LEADS = 'UPDATE_FILTER_EVERGREEN_LEADS';

export const GET_DUPLICATE = 'GET_DUPLICATE';
export const GET_DUPLICATE_SUCCESS = 'GET_DUPLICATE_SUCCESS';
export const GET_DUPLICATE_FAILURE = 'GET_DUPLICATE_FAILURE';

export const GET_ACTIVITIES = 'GET_ACTIVITIES';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
export const GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE';
export const CREATE_ACTIVITY = 'CREATE_ACTIVITY';
export const CREATE_ACTIVITY_SUCCESS = 'CREATE_ACTIVITY_SUCCESS';
export const CREATE_ACTIVITY_FAILURE = 'CREATE_ACTIVITY_FAILURE';
export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY';
export const UPDATE_ACTIVITY_SUCCESS = 'UPDATE_ACTIVITY_SUCCESS';
export const UPDATE_ACTIVITY_FAILURE = 'UPDATE_ACTIVITY_FAILURE';

export const GET_EVERGREEN_LEADS_SUGGESTION_SUCCESS = 'GET_EVERGREEN_LEADS_SUGGESTION_SUCCESS';
export const GET_EVERGREEN_LEADS_SUGGESTION_FAILURE = 'GET_EVERGREEN_LEADS_SUGGESTION_FAILURE';

export const GET_LOG = 'GET_LOG';
export const GET_LOG_SUCCESS = 'GET_LOG_SUCCESS';
export const GET_LOG_FAILURE = 'GET_LOG_FAILURE';

export const CONVERT_TO_EVERGREEN_LEAD = 'CONVERT_TO_EVERGREEN_LEAD';
export const CONVERT_TO_EVERGREEN_LEAD_SUCCESS = 'CONVERT_TO_EVERGREEN_LEAD_SUCCESS';
export const CONVERT_TO_EVERGREEN_LEAD_FAILURE = 'CONVERT_TO_EVERGREEN_LEAD_FAILURE';

export const EVERGREEN_LEAD_ASSIGN = 'EVERGREEN_LEAD_ASSIGN';
export const EVERGREEN_LEAD_ASSIGN_SUCCESS = 'EVERGREEN_LEAD_ASSIGN_SUCCESS';
export const EVERGREEN_LEAD_ASSIGN_FAILURE = 'EVERGREEN_LEAD_ASSIGN_FAILURE';

export const IMPORT_EVERGREEN_LEADS = 'IMPORT_EVERGREEN_LEADS';
export const IMPORT_EVERGREEN_LEADS_SUCCESS = 'IMPORT_EVERGREEN_LEADS_SUCCESS';
export const IMPORT_EVERGREEN_LEADS_FAILURE = 'IMPORT_EVERGREEN_LEADS_FAILURE';

export type EvergreenLeadsType = {
  data: any;
};
export interface GetEvergreenLeads {
  type: typeof GET_EVERGREEN_LEADS;
}
export interface GetEvergreenLeadsSuccess {
  type: typeof GET_EVERGREEN_LEADS_SUCCESS;
  payload: EvergreenLeadsType;
}
export interface GetEvergreenLeadsFailure {
  type: typeof GET_EVERGREEN_LEADS_FAILURE;
  message: string;
}
export interface GetEvergreenLead {
  type: typeof GET_EVERGREEN_LEAD;
}
export interface GetEvergreenLeadSuccess {
  type: typeof GET_EVERGREEN_LEAD_SUCCESS;
  payload: any;
}
export interface GetEvergreenLeadFailure {
  type: typeof GET_EVERGREEN_LEAD_FAILURE;
  message: any;
}
export interface UpdateEvergreenLead {
  type: typeof UPDATE_EVERGREEN_LEAD;
}
export interface UpdateEvergreenLeadSuccess {
  type: typeof UPDATE_EVERGREEN_LEAD_SUCCESS;
  payload: any;
}
export interface UpdateEvergreenLeadFailure {
  type: typeof UPDATE_EVERGREEN_LEAD_FAILURE;
  message: any;
}
export interface UpdateFilterEvergreenLeads {
  type: typeof UPDATE_FILTER_EVERGREEN_LEADS;
  payload: any;
}
export interface GetDuplicate {
  type: typeof GET_DUPLICATE;
}
export interface GetDuplicateSuccess {
  type: typeof GET_DUPLICATE_SUCCESS;
  payload: any;
}
export interface GetDuplicateFailure {
  type: typeof GET_DUPLICATE_FAILURE;
  message: any;
}
//Activities
export interface GetActivities {
  type: typeof GET_ACTIVITIES;
}
export interface GetActivitiesSuccess {
  type: typeof GET_ACTIVITIES_SUCCESS;
  payload: any;
}
export interface GetActivitiesFailure {
  type: typeof GET_ACTIVITIES_FAILURE;
  message: any;
}
export interface CreateActivity {
  type: typeof CREATE_ACTIVITY;
}
export interface CreateActivitySuccess {
  type: typeof CREATE_ACTIVITY_SUCCESS;
}
export interface CreateActivityFailure {
  type: typeof CREATE_ACTIVITY_FAILURE;
  message: any;
}
export interface UpdateActivity {
  type: typeof UPDATE_ACTIVITY;
}
export interface UpdateActivitySuccess {
  type: typeof UPDATE_ACTIVITY_SUCCESS;
  payload: any;
}
export interface UpdateActivityFailure {
  type: typeof UPDATE_ACTIVITY_FAILURE;
  message: any;
}
export interface CreateEvergreenLead {
  type: typeof CREATE_EVERGREEN_LEAD;
}
export interface CreateEvergreenLeadSuccess {
  type: typeof CREATE_EVERGREEN_LEAD_SUCCESS;
  payload: any;
}
export interface CreateEvergreenLeadFailure {
  type: typeof CREATE_EVERGREEN_LEAD_FAILURE;
  message: any;
}
export interface GetEvergreenLeadsSuggestionSuccess {
  type: typeof GET_EVERGREEN_LEADS_SUGGESTION_SUCCESS;
  payload: EvergreenLeadsType;
}
export interface GetEvergreenLeadsSuggestionFailure {
  type: typeof GET_EVERGREEN_LEADS_SUGGESTION_FAILURE;
}
export interface GetLog {
  type: typeof GET_LOG;
}
export interface GetLogSuccess {
  type: typeof GET_LOG_SUCCESS;
  payload: any;
}
export interface GetLogFailure {
  type: typeof GET_LOG_FAILURE;
  message: any;
}
export interface ConvertToEvergreenLead {
  type: typeof CONVERT_TO_EVERGREEN_LEAD;
}

export interface ConvertToEvergreenLeadSuccess {
  type: typeof CONVERT_TO_EVERGREEN_LEAD_SUCCESS;
  message: string;
}

export interface ConvertToEvergreenLeadFailure {
  type: typeof CONVERT_TO_EVERGREEN_LEAD_FAILURE;
  message: string;
}

export interface EvergreenLeadAssigns {
  type: typeof EVERGREEN_LEAD_ASSIGN;
}

export interface EvergreenLeadAssignsSuccess {
  type: typeof EVERGREEN_LEAD_ASSIGN_SUCCESS;
  message: string;
}

export interface EvergreenLeadAssignsFailure {
  type: typeof EVERGREEN_LEAD_ASSIGN_FAILURE;
  message: string;
}
export interface ImportEvergreenLeads {
  type: typeof IMPORT_EVERGREEN_LEADS;
}
export interface ImportEvergreenLeadsSuccess {
  type: typeof IMPORT_EVERGREEN_LEADS_SUCCESS;
}
export interface ImportEvergreenLeadsFailure {
  type: typeof IMPORT_EVERGREEN_LEADS_FAILURE;
  message: any;
}

export type EvergreenLeadsDispatchTypes =
  | GetEvergreenLeads
  | GetEvergreenLeadsSuccess
  | GetEvergreenLeadsFailure
  | GetEvergreenLead
  | GetEvergreenLeadSuccess
  | GetEvergreenLeadFailure
  | UpdateEvergreenLead
  | UpdateEvergreenLeadSuccess
  | UpdateEvergreenLeadFailure
  | UpdateFilterEvergreenLeads
  | GetDuplicate
  | GetDuplicateSuccess
  | GetDuplicateFailure
  | GetActivities
  | GetActivitiesSuccess
  | GetActivitiesFailure
  | CreateActivity
  | CreateActivitySuccess
  | CreateActivityFailure
  | UpdateActivity
  | UpdateActivitySuccess
  | UpdateActivityFailure
  | CreateEvergreenLead
  | CreateEvergreenLeadSuccess
  | CreateEvergreenLeadFailure
  | GetEvergreenLeadsSuggestionSuccess
  | GetEvergreenLeadsSuggestionFailure
  | GetLog
  | GetLogSuccess
  | GetLogFailure
  | ConvertToEvergreenLead
  | ConvertToEvergreenLeadSuccess
  | ConvertToEvergreenLeadFailure
  | EvergreenLeadAssigns
  | EvergreenLeadAssignsSuccess
  | EvergreenLeadAssignsFailure
  | ImportEvergreenLeads
  | ImportEvergreenLeadsSuccess
  | ImportEvergreenLeadsFailure;
